import { render, staticRenderFns } from "./ImageSectionText.vue?vue&type=template&id=3c8bc1bc&"
import script from "./ImageSectionText.vue?vue&type=script&lang=js&"
export * from "./ImageSectionText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports